// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"9d2df395","787":"7c9d5f10"}[chunkId] + ".chunk.js";
};